function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.5 14.5V.5h19v14H.5z",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "square"
});
var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "send_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.166.833L10 9.167.833.833"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.839 1.573l.74-.672-1.345-1.48-.74.672 1.345 1.48zm-9.84 7.594l-.672.74h1.345L10 9.167zM1.507.093l-.74-.672L-.58.9l.74.672L1.506.093zm16.988 0L9.327 8.427l1.345 1.48 9.167-8.334-1.345-1.48zm-7.822 8.334L1.506.093.16 1.573l9.167 8.334 1.345-1.48z",
  fill: "params(fill) #211FAB",
  mask: "url(#send_svg__a)"
});
function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}
export default SvgSend;